<style scoped>

.navbar-brand .logo {
    width: 120px;
    height: auto;
    max-height: none !important;
}

.navbar-item__partner-container {
    max-width: 152px;
}

.navbar-item__partner-img {
    width: auto;
    height: auto;
    max-height: 37px;
    margin-left: 5px;
}

</style>

<template>
  <div class="section p-0 pt-2">
    <div class="container">
      <div class="columns is-mobile page-header">
        <svg fill="none" class="is-hidden" xmlns="http://www.w3.org/2000/svg">
          <symbol id="initio_tick_icon" width="28" height="28" viewBox="0 0 16 16"  >
            <g>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 8C0 3.57583 3.57583 0 8 0C12.4242 0 16 3.57583 16 8C16 12.4242 12.4242 16 8 16C3.57583 16 0 12.4242 0 8ZM6.61736 11.2814C6.8017 11.2814 6.98604 11.208 7.13366 11.0604L11.8711 6.34085C12.1476 6.06434 12.1476 5.58477 11.8711 5.29025C11.5766 4.99501 11.1158 4.99501 10.8205 5.29025L6.61739 9.4934L4.81071 7.68671C4.51621 7.39147 4.05536 7.39147 3.76012 7.68671C3.46488 7.98122 3.46488 8.44207 3.76012 8.73731L6.10106 11.0604C6.22995 11.208 6.43302 11.2814 6.61736 11.2814Z" fill="#82B541"/>
              </svg>
            </g>
          </symbol>
          <symbol id="initio_cross_icon" width="28" height="28" viewBox="0 0 16 16"  >
            <g>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8 0C3.58754 0 0 3.58754 0 8C0 12.4125 3.58754 16 8 16C12.4125 16 16 12.4125 16 8C16 3.58754 12.4125 0 8 0ZM11.0651 9.76842C11.419 10.1224 11.419 10.7118 11.0651 11.0651C10.8796 11.2507 10.6612 11.3349 10.425 11.3349C10.1894 11.3349 9.95325 11.2507 9.78483 11.0651L7.9999 9.29671L6.23148 11.0651C6.04595 11.2507 5.82754 11.3349 5.59134 11.3349C5.35582 11.3349 5.11963 11.2507 4.95121 11.0651C4.59726 10.7112 4.59726 10.1217 4.95121 9.76842L6.70312 8L4.9347 6.23158C4.58075 5.87763 4.58075 5.28815 4.9347 4.93487C5.28866 4.58092 5.87813 4.58092 6.23141 4.93487L7.99983 6.70329L9.76825 4.93487C10.1222 4.58092 10.7117 4.58092 11.065 4.93487C11.4189 5.28883 11.4189 5.8783 11.065 6.23158L9.29654 8L11.0651 9.76842Z" fill="#B54141"/>
              </svg>
            </g>
          </symbol>
        </svg>
        <div class="column is-5">
            <div class="navbar-brand">
                <a href="/" class="navbar-item navbar-item__logo">
                    <img class="logo mr-2" src="/assets/images/2018/initio-insurance.svg" alt="Initio - House insurance online" title="Initio - House insurance online">
                </a>
                <div v-if="resellerLogoUrl" class="navbar-item p-0">
                    <svg width="1" height="35" viewBox="0 0 1 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <line x1="0.5" y1="35" x2="0.500002" y2="-2.18557e-08" stroke="#DFE3E8"/>
                    </svg>
                </div>
                <div v-if="resellerLogoUrl" class="navbar-item__partner-container py-2 px-3 is-flex is-align-items-center">
                    <img class="navbar-item__partner-img" v-bind:src="resellerLogoUrl" alt="Initio Partnership" title="Initio Partnership"/>
                </div>
            </div>
        </div>
        <div class="column is-7 has-text-right my-auto">
          <a v-if="isLoggedIn" href="/app/member/dashboard" class="button is-secondary">Dashboard</a>
          <span v-else><strong>Already have an account?</strong> <a href="/app/login">Login</a></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  export default {
    components: {},
    methods: {},
    computed: {    ...mapGetters({
        isLoggedIn: 'isLoggedIn',
        resellerLogoUrl: 'getResellerLogoUrl',
      })
    },
    data () {
      return {}
    },
  }

</script>
